import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";

import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Spinner,
} from "reactstrap";
import Spinners from "components/Common/Spinner";

import Select from "react-select";
import InputMask from "react-input-mask";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar.png";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import Config from "config";
const UserChangePassword = () => {
  const api = Config.backOffice.apiName;
  //meta title
  document.title = "Profile | DOM COM";
  const [loading, setLoading] = useState(true);
  const colStyle = { width: "25em", whiteSpace: "nowrap" };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    window.location.reload();
  };
  const dispatch = useDispatch();
  const token = localStorage.getItem("auth_token");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  // autres variables PP
  const [conseil, setConseil] = useState("");

  /******************* end P M ********************/

  const selectProfileState = (state) => state.Profile;
  const ProfileProperties = createSelector(selectProfileState, (profile) => ({
    error: profile.error,
    success: profile.success,
  }));

  const { error, success } = useSelector(ProfileProperties);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = localStorage.getItem("authUser");

      setTimeout(() => {
        // dispatch(resetProfileFlag());
        setLoading(false);
      }, 100);
    }
  }, [dispatch, success]);
  useEffect(() => {
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || "",
      idx: idx || "",
      titre: "",
      conseil: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
      titre: Yup.string().required("res"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    },
  });
  const validationType = useFormik({
    enableReinitialize: true,
    initialValues: {
      oldPassword: "",
      password: "",
      password1: "",
    },
    validationSchema: Yup.object().shape({
      oldPassword: Yup.string().required("Entrez l'ancien mot de passe"),
      password: Yup.string()
        .notOneOf(
          [Yup.ref("oldPassword")],
          "Le nouveau mot de passe ne doit pas être identique à l'ancien"
        )
        .required("Entrez le nouveau mot de passe"),
      password1: Yup.string()
        .required("Entrez la confirmation du mot de passe")
        .when("password", (password, schema) => {
          return password && password.length > 0
            ? schema.oneOf(
                [Yup.ref("password")],
                "Les mots de passe ne sont pas identiques"
              )
            : schema.required("Entrez la confirmation du mot de passe");
        }),
    }),

    onSubmit: async (values) => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fdashboards/update_password`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              old_password: values.oldPassword,
              password: values.password,
              password_confirmation: values.password1,
            }),
          }
        );

        if (response.ok) {
          console.log("Post request successful");
          handleNavigate();
        } else {
          console.error("Post request failed");
          const responseData = await response.json();
          console.log(responseData.error);
          toast.error(responseData.error);
          if (responseData && responseData.error) {
            const errors = responseData?.error;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        // toast.error("Une erreur s'est produite");
      }
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {!loading && (
            <Card className="mb-4">
              <CardTitle
                tag="h5"
                style={{ paddingLeft: "10px", paddingTop: "10px" }}
              >
                Changement de mot de passe
              </CardTitle>
              <CardBody>
                <Row className="mb-1">
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationType.handleSubmit();
                      return false;
                    }}
                    autoComplete="off"
                  >
                    <div className="mb-3">
                      <Label className="form-label">Ancien mot de passe</Label>
                      <Input
                        name="oldPassword"
                        placeholder="Ancien mot de passe"
                        type="password"
                        autoComplete="off"
                        onChange={validationType.handleChange}
                        onBlur={validationType.handleBlur}
                        value={validationType.values.oldPassword || ""}
                        invalid={
                          validationType.touched.oldPassword &&
                          validationType.errors.oldPassword
                            ? true
                            : false
                        }
                      />
                      {validationType.touched.oldPassword &&
                      validationType.errors.oldPassword ? (
                        <FormFeedback type="invalid">
                          {validationType.errors.oldPassword}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label>Nouveau mot de passe</Label>
                      <Input
                        name="password"
                        type="password"
                        autoComplete="off"
                        placeholder="Entrez le mot de passe"
                        onChange={validationType.handleChange}
                        onBlur={validationType.handleBlur}
                        value={validationType.values.password || ""}
                        invalid={
                          validationType.touched.password &&
                          validationType.errors.password
                            ? true
                            : false
                        }
                      />
                      {validationType.touched.password &&
                      validationType.errors.password ? (
                        <FormFeedback type="invalid">
                          {validationType.errors.password}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Input
                        name="password1"
                        type="password"
                        autoComplete="off"
                        placeholder="Confirmer le mot de passe"
                        onChange={validationType.handleChange}
                        onBlur={validationType.handleBlur}
                        value={validationType.values.password1 || ""}
                        invalid={
                          validationType.touched.password1 &&
                          validationType.errors.password1
                            ? true
                            : false
                        }
                      />
                      {validationType.touched.password1 &&
                      validationType.errors.password1 ? (
                        <FormFeedback type="invalid">
                          {validationType.errors.password1}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="text-center mt-3">
                      <Button type="submit" color="danger">
                        Modifier le mot de passe
                      </Button>{" "}
                    </div>
                  </Form>
                </Row>
              </CardBody>
            </Card>
          )}
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default withRouter(UserChangePassword);
{
  /*  */
}
